import React from "react";
import Markdown from "react-markdown";

import Icon from "@/components/ui/icon";

type SourceGroup = {
	content: string;
	avail_text: string;
	source: string;
	link: string;
};

export default function DataAccess({
	data_access_desc,
	data_access_sources,
}: {
	data_access_desc?: string;
	data_access_sources?: string;
}) {
	let parsedDataAccessSources: SourceGroup[] | undefined;

	try {
		if (data_access_sources) {
			parsedDataAccessSources = JSON.parse(data_access_sources)?.sources;
		}
	} catch (error) {
		console.error("Failed to parse data_access_sources:", error);
	}

	return (
		<div className="tab-pane fade show active">
			{data_access_desc && (
				<div className="g2-text-grey mb-3">
					<Markdown>{data_access_desc}</Markdown>
				</div>
			)}

			{parsedDataAccessSources && (
				<table className="table table-hover table-striped w-100">
					<tbody>
						{parsedDataAccessSources.map((group, index) => {
							const items = group.content
								.split(/<br\s*\/?>|\r?\n/)
								.map((item) => item.trim())
								.filter(Boolean);

							return (
								<tr key={index}>
									<td className="w-50 align-top">
										{items.map((item, idx) => (
											<div key={idx} className="text-black text-end">
												{item}
											</div>
										))}
									</td>
									<td className="w-50 align-top">
										<span className="text-black">{group.avail_text} </span>
										<a
											href={group.link}
											target="_blank"
											className="g2-link-blue d-block fw-bold text-decoration-none"
										>
											{group.source}
											<Icon icon="box-arrow-up-right" ms={2} />
										</a>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			)}
		</div>
	);
}
